import React, { useEffect, useState, useRef } from "react";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";
import { Image } from "@project-stories/elements/Image/Image";

export const CarouselLayout = ({ settings, images, videoUrl }) => {
  const carouselRef = useRef(null);
  const showNavigation = true;
    const { globals } = settings;

  return (
    <div className={`image-carousel`}>
      {/* {showNavigation && images.length > 1 && (
        <div className={"banner-carousel__controls z-[5]"}>
          <CarouselNavigation
            shiftPageDots={false}
            carouselRef={carouselRef}
            spread={true}
            icons={globals?.carousel_icons}
            size={globals?.carousel_icons?.carousel_navigation_arrow_size}
          />
        </div>
      )} */}
      <div
        className="carousel-images carousel w-full h-auto"
        {...(true && {
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(false, true, false, false, 0, 'productgallery', true, false) })`,
          "x-ref": "carousel",
        })}
        ref={carouselRef}
      >
        {images.map((image, index) => (
          <div key={index} className="carousel-cell w-full">
            <Image
              key={index}
              imageUrl={image.url}
              alt={image.alt}
              useSrcSet={true}
              classes={'w-full h-full object-cover'}
              isLazy={index < 1 ? settings.section.is_lazy_load : true}
            />
          </div>
        ))}
        {videoUrl && (
          <div
            key={"video"}
            className="video-item"
            style={{ height: "100%", width: "100%", pointerEvents: "none" }}
          >
            <div className="video-iframe h-full" data-v-2da62827="">
              <iframe
                src={videoUrl}
                width="100%"
                height="100%"
                data-v-2da62827=""
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
